
let donateLinks = {
    georgeFloydMem : {
        title : 'Official George Floyd Memorial Fund',
        desc : 'This fund is established to cover funeral and burial expenses, mental and grief counseling, lodging and travel for all court proceedings, and to assist our family in the days to come as we continue to seek justice for George.  A portion of these funds will also go to the Estate of George Floyd for the benefit and care of his children and their educational fund.',
        link : 'https://www.gofundme.com/f/georgefloyd?utm_source=customer&utm_medium=copy_link-tip&utm_campaign=p_cp+share-sheet'
    },
    indyBailFund : {
        title : 'The Bail Project',
        desc : "Join our 8,000+ donors who are helping us post bail for people who can't afford it, reuniting families and restoring the presumption of innocence – one person at a time.",
        link: 'https://secure.givelively.org/donate/the-bail-project'
    },
    nationalBailFund : {
        title : 'National Bail Fund Network',
        desc : 'The National Bail Fund Network is made up of over sixty community bail and bond funds across the country.',
        link: 'https://www.communityjusticeexchange.org/nbfn-directory'
    },
    campaignZero : {
        title : 'Campaign Zero',
        desc : 'Online platform and organization that utilizes research-based policy solutions to end police brutality in America.',
        link: 'https://www.joincampaignzero.org/'
    },
    minnesotaFreeFund : {
        title : 'Minnesota Freedom Fund',
        desc : 'Community-based nonprofit that pays criminal bail and immigration bonds for individuals who have been arrested while protesting police brutality.',
        link: 'https://minnesotafreedomfund.org/donate'
    },
    blackVisionsCollective : {
        title : 'Black Visions Collective',
        desc : 'A black, trans, and queer-led organization that is committed to dismantling systems of oppression and violence, and shifting the public narrative to create transformative, long-term change. ',
        link: 'https://secure.everyaction.com/4omQDAR0oUiUagTu0EG-Ig2'
    },
    reclaimBlock : {
        title : 'Reclaim The Block',
        desc : 'Coalation that advocates for and invests in community-led safety initiatives in Minneapolis neighborhoods.',
        link: 'https://secure.everyaction.com/zae4prEeKESHBy0MKXTIcQ2'
    },
    unicornRiot : {
        title : 'Unicorn Riot',
        desc : 'Non-profit organization that is dedicated to exposing root causes of dynamic social and environmental issues.',
        link: 'https://unicornriot.ninja/donate/'
    },
     naacp : {
        title: 'NAACP | We Are Done Dying',
        desc: 'Demand appointment of an independent special prosecutor to lead the federal government’s full and impartial investigation of the murder of George Floyd. Demand appointment of an independent special prosecutor to lead the federal government’s full and impartial investigation of the murder of George Floyd.',
        link: 'https://secure.actblue.com/donate/naacp-1'
    },
    npap : {
        title: 'National Police Accountability Project',
        desc: 'Educates and informs the public about issues relating to police misconduct. Provides infromation resources for non-profit and community groups who work with victims of police abuse.',
        link: 'https://www.nlg-npap.org/donate/'
    },
    innocence : {
        title: 'Innocence Project',
        desc: 'Become a part of the Innocence Project’s community of monthly supporters who give to free innocent people and transform the legal system. With your support, we can do even more in 2020 — donate monthly today.',
        link: 'https://www.innocenceproject.org/donate-monthly/?f_src=FY20_pmweb_x_gen_nmat_campinnocence-advocates-2019_go_dd_innocence-advocates-2019_brand&gclid=Cj0KCQjwlN32BRCCARIsADZ-J4vGp0RrqVRSoyNNyNUf2VyPmR5t8UD7bg-8tfv8kTkxzyqEjlBajMIaAmyIEALw_wcB',
    },
    blm : {
        title: 'Black Lives Matter',
        desc: 'We appreciate your support of the movement and our ongoing fight to end state-sanctioned violence, liberate Black people, and end white supremacy forever. Donate to fuel our campaigns for justice.',
        link: 'https://secure.actblue.com/donate/ms_blm_homepage_2019',
    },
    duNord : {
        title: 'Du Nord Riot Recovery Fund',
        desc: ' Du Nord is establishing this fund to support black and brown companies affected by the riots. In the coming days we will add to the leadership team to bring in more business owners and community leaders.  We are dedicated to rebuilding Minneapolis in a way that ensures our cultural beacons are restored.',
        link: 'https://www.gofundme.com/f/minnesota-poc-business-support',
    },
    smallBusiness : {
        title: 'Small Family Business Looted In Minneapolis',
        desc: 'The funds will go to pay off debts, pay for property damages and help us get started once again. Thank you once again, God Bless. ',
        link: 'https://www.gofundme.com/f/small-family-business-looted-in-lake-street-riot',
    },
    loveLand : {
        title: 'The Love Land Foundation',
        desc: '"The Loveland Foundation, started by Rachel Cargle, is a nonprofit that provides financial assistance for Black women and girls seeking mental health support. “',
        link: 'https://thelovelandfoundation.org/',
    },
    againstPoliceBrutality : {
        title: 'Communities United Against Police Brutality',
        desc: '"Communities United Against Police Brutality (CUAPB) operates a 24-hour hotline in Minneapolis for people to report instances of abuse in their area. If needed, CUAPB will send out a crisis team to investigate the report, offer immediate assistance, and provide legal, medical, and psychological resources into the future. CUAPB also provides educational programs to teach communities about the detriments of police brutality and justice system issues."',
        link: 'https://www.cuapb.org/who_we_are',
    },
    fairFight : {
        title: 'Fair Fight',
        desc: '"There is so much to be done, but I keep coming back to the need for fair elections. Voter suppression is widespread and endemic in this country and an election year is yet another reminder that our government cannot make progress until people of color are not disenfranchised at an alarming rate. This organization, founded by Stacy Abrams, is working to ensure free and fair elections."',
        link: 'https://fairfight.com/',
    },
    brennanCenter : {
        title: 'Brennan Center For Justice',
        desc: '"One major long term strategy for achieving social justice is ensuring that we have a real democracy in which all voices are heard. The Brennan Center fights for voting rights, election security, campaign finance reform, electoral college reform, and an end to mass incarceration, among other avenues to achieving justice and fair representation."',
        link: 'https://www.brennancenter.org/',
    },
    committeeJourn : {
        title: 'Committee To Protect Journalists',
        desc: '"The arrest of CNN correspondent Omar Jimenez is only the most prominent example of widespread attacks on journalists right now, not just those covering the protests that erupted in the aftermath of George Floyd’s killing but those who’ve been tirelessly speaking truth to power for the last four years. The Committee to Protect Journalists is a lifeline for members of the media to continue pursuing their important reporting at a time when the freedom of the press is under siege."',
        link: 'https://cpj.org/donate',
    },
    southernPov : {
        title: 'The Southern Poverty Law Center',
        desc: '"From monitoring hate groups to seeking justice for vulnerable people and educating youth on the value of diversity, the Southern Poverty Law Center is doing the work to fight hate and systemic bigotry in this country."',
        link: 'https://donate.splcenter.org/',
    },
    equalJustice : {
        title: 'Equal Justice Initiative',
        desc: 'The Equal Justice Initiative is committed to ending mass incarceration and excessive punishment in the United States, to challenging racial and economic injustice, and to protecting basic human rights for the most vulnerable people in American society.',
        link: 'https://eji.org/'
    },
    blackFuturesLab : {
        title: 'Black Futures Lab',
        desc: 'Black Futures Lab works with Black people to transform our communities, building Black political power and changing the way that power operates—locally, statewide, and nationally.',
        link: 'https://blackfutureslab.org/'
    },
    snap4freedom: {
        title: 'SNAPCO',
        desc: 'Builds power of Black Trans and queer people to force systemic divestment from the prison industiral complex and invest in community support.',
        link: 'https://www.snap4freedom.org/'
    },
    blackAidsInstitute: {
        title: 'Black AIDS Institute',
        desc: 'Working to end the Black HIV epidemic through policy, advocacy, and high-quality direct HIV services.',
        link: 'https://blackaids.org/'
    },
    houseGG: {
        title: 'HOUSE OF GG',
        desc: 'Creating safe and transformative spaces for community to heal, and nurturing them into tomorrows leaders, focusing on trans women of color in the South.',
        link: 'https://houseofgg.org/'
    },
    transJustice: {
        title: 'Trans Justice Funding Project',
        desc: 'Community-led funding initiative to support grassroots trans justice groups run by and for trans people.',
        link: 'https://www.transjusticefundingproject.org/'
    },
    okraProject: {
        title: 'The OKRA Project',
        desc: 'Collective that seeks to address the global crisis faced by Black Trans people by bringing home-cooked meals and resources to the community.',
        link: 'https://www.theokraproject.com/'
    }


}

export default donateLinks;